import React from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import LoaderModel from '../../models/shared/LoaderModel';

interface LoaderProps {
    loader: LoaderModel,
}

@observer
class Loader extends React.Component<LoaderProps, any> {
    render() {
        const { loader } = this.props;
        const className = classNames("loader", { "loader--is-open": loader.isOpen });

        return (
            <div className={className} >
                <div className="loader__center">
                    <div className="loader__icon" />
                    <div className="loader__title" >
                        {loader.title}
                    </div>
                </div>
            </div>
        );
    }
}

export default Loader;
